export default {
    name: {
        label: 'Name',
        placeholder: 'Name',
    },
    save: 'Save',
    cancel: 'Cancel',
    title: {
        create: 'Create sub folder for',
        update: 'Update folder',
    },
    button: {
        save: 'Save',
        create: 'Create sub folder',
        edit: 'Edit',
        delete: 'Delete',
        upload: 'Upload',
    },
    error: {
        invalidFolderName:
            'The folder name should contain only alphabets, numbers, dash and spaces',
    },
    success: {
        create: 'The folder has been created',
        update: 'The folder has been updated',
        delete: 'The folder has been deleted',
        move: 'Moved file successful',
    },
    delete: {
        confirm: {
            title: 'Delete folder',
            message: 'Are you sure to delete this folder?',
        },
    },
    tooltip: 'Right click to see options',
};
